module.exports = __webpack_public_path__ + "img/18daf43.jpg";